import { TikTokLogo } from '@/assets/svg';
import BaseSocialModal from './BaseSocialModal';

export default class TikTok extends BaseSocialModal {
  constructor(props) {
    super(props, 'TikTok');
    this.logo = TikTokLogo;
  }

  render() {
    return this.renderSocialModal();
  }
}
